var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 38,
    viewBox: "0 0 20 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3067_196469",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 38
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(0.83205 0.5547 0 1 0.03125 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3067_196469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.02355 20.7938L14.0112 26.1189C14.982 26.7661 15.8071 26.9078 16.4866 26.5442C17.1661 26.1805 17.5058 25.4154 17.5058 24.2487C17.5058 23.082 17.1661 21.8639 16.4866 20.5942C15.8071 19.3245 14.982 18.3661 14.0112 17.7189L6.02355 12.3938C5.05283 11.7467 4.22771 11.6049 3.5482 11.9686C2.86869 12.3323 2.52894 13.0974 2.52894 14.2641C2.52894 15.4308 2.86869 16.6489 3.5482 17.9186C4.22771 19.1883 5.05283 20.1467 6.02355 20.7938ZM8.5197 12.2579L11.5151 14.2548V13.0548L8.5197 11.0579V12.2579ZM7.52124 23.5923V25.0923C7.52124 25.3473 7.44989 25.5135 7.3072 25.5908C7.1645 25.6682 6.98769 25.6366 6.77677 25.496C6.56584 25.3554 6.38757 25.1503 6.24196 24.8807C6.09636 24.6111 6.02355 24.3488 6.02355 24.0938V22.5938C4.6368 21.6693 3.45806 20.3002 2.48734 18.4864C1.51661 16.6725 1.03125 14.9323 1.03125 13.2656C1.03125 11.599 1.51661 10.5059 2.48734 9.98635C3.45806 9.46683 4.6368 9.66933 6.02355 10.5938L7.02201 11.2595V10.0595C7.02201 9.56447 7.16887 9.23862 7.46258 9.08193C7.75616 8.92515 8.10916 8.98423 8.52157 9.25917L11.5205 11.2585C11.9329 11.5334 12.2847 11.9442 12.5759 12.4908C12.8672 13.0375 13.0128 13.5583 13.0128 14.0533V15.2533L14.0112 15.9189C15.398 16.8434 16.5767 18.2126 17.5474 20.0264C18.5182 21.8402 19.0035 23.5805 19.0035 25.2471C19.0035 26.9138 18.5182 28.0069 17.5474 28.5264C16.5767 29.0459 15.398 28.8434 14.0112 27.9189V29.4189C14.0112 29.6739 13.9399 29.8401 13.7972 29.9175C13.6545 29.9949 13.4777 29.9632 13.2668 29.8226C13.0558 29.682 12.8776 29.4769 12.732 29.2073C12.5863 28.9378 12.5135 28.6755 12.5135 28.4205V26.9205L7.52124 23.5923Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasolio);
export default __webpack_public_path__ + "static/media/gasolio.464b81d329dc729a4a186964adff2b96.svg";
export { ForwardRef as ReactComponent };